<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Consulta de Solicitudes de Retiro" description="" />
      <RetirementRequested/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import RetirementRequested from '@/components/Retirement/RetirementRequested.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {}
  },
  name: 'RetirementRequestedView',
  components: {
    RetirementRequested,
    Header,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>